import { render, staticRenderFns } from "./RupeeLoader.vue?vue&type=template&id=08d9d86f&scoped=true&"
import script from "./RupeeLoader.vue?vue&type=script&lang=js&"
export * from "./RupeeLoader.vue?vue&type=script&lang=js&"
import style0 from "./RupeeLoader.vue?vue&type=style&index=0&id=08d9d86f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d9d86f",
  null
  
)

export default component.exports